<script>
    // Licensed under Gnu Public Licence version 2
    // Copyright (c) 2026 (original work) Open Assessment Technologies SA ;
    export let data;

    $: detailsText = [data?.data, data?.span].filter(Boolean).join(' ');
</script>

{#if detailsText}
    <div class="details-cell" title={detailsText}>
        <span class="details-cell__content">{data?.data || ''}</span>
        {#if data?.span}
            <span class="details-cell__meta">{data.span}</span>
        {/if}
    </div>
{:else}
    -
{/if}

<style>
    .details-cell {
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: normal;
        word-break: break-word;
    }

    .details-cell__content,
    .details-cell__meta {
        display: inline;
    }

    .details-cell__meta {
        color: var(--color-text-feedback);
    }
</style>
